import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IHttpBasicResponse, JsonApiResponse } from '@boxx/core';
import {
  IGBMConversationListApi,
  IGBMConversationMessageListApi,
  IGBMConversationMessageReplyApi,
} from '../models/GBMessages-api.properties';
import { ILeadApi, ILeadsApi } from '../models/Leads-api.properties';
import {
  IReviewApi,
  IReviewLink,
  IReviewsApi,
  IReviewUpsertApi,
} from '../models/Reviews-api.properties';
import { NotificationModel } from '../models/Notification.model';

export interface IMessagesRepository {
  //LEADS
  getLeads(): Observable<JsonApiResponse<ILeadsApi>>;
  setLeadAsRead(id: number): Observable<JsonApiResponse<ILeadApi>>;

  // REVIEWS
  getReviews(): Observable<IHttpBasicResponse<IReviewsApi>>;
  getReview(reviewId: string): Observable<IHttpBasicResponse<IReviewApi>>;
  upsertReply(
    reviewId: string,
    comment: string
  ): Observable<IHttpBasicResponse<IReviewUpsertApi>>;
  deleteReply(reviewId: string): Observable<IHttpBasicResponse<null>>;
  getReviewLink(): Observable<JsonApiResponse<IReviewLink>>;

  //GOOGLE MESSAGES
  getNotifications(): Observable<IHttpBasicResponse<any>>;
  setNotificationAsRead(id: number): Observable<any>;
  deleteNotification(id: number): Observable<IHttpBasicResponse<null>>;

  // GBM
  getGBMConversationList(): Observable<
    IHttpBasicResponse<IGBMConversationListApi>
  >;
  getGBMMessageList(
    conversationId: string
  ): Observable<IHttpBasicResponse<any>>;
  replyGBMMessage(
    conversationId: string,
    message: string
  ): Observable<IHttpBasicResponse<IGBMConversationMessageReplyApi>>;
}

export const MESSAGES_REPOSITORY = new InjectionToken<IMessagesRepository>(
  'messagesRepository'
);
